import { observer } from "mobx-react-lite";
import { Button } from "semantic-ui-react";
import React from "react";
import Container from 'react-bootstrap/Container';
import Modal from 'react-bootstrap/Modal';
import { useStore } from "../../../app/stores/store";

interface Props {
    key: number;
        show: any,
        onHide: any,
        appUserId: string,
        catEdicionesId: number,
        nombres: string,
        apellidos: string,
        dpi: number,
        codigoInstitucional: string
        updateStudentList: () => void
}


export default observer(function ModalDesmatricular(props: Props) {

    const { InscriptionsStore } = useStore();

    function handleDelete(){
        console.log("app user id: ",props.appUserId);
        console.log("catedicionesid: ",props.catEdicionesId);
        console.log("codigo Institucional: ",props.codigoInstitucional);

        let Inscription = {
            id: 0,
            appUserId: props.appUserId,
            codigoCursoId: props.catEdicionesId,
            solicitud: "",
            codigoInstitucional: props.codigoInstitucional,
          };
        
          InscriptionsStore.deleteInscription(Inscription).then(() => {
            props.updateStudentList();
          });
        
    }

    return (

        <>
            <Modal
                {...props}
                size="lg"
                className="modal-add-dep-content modal-desmatricular"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton >
                    <Modal.Title id="contained-modal-title-vcenter">
                        Desmatricular: {props.nombres + " " + props.apellidos}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Container className="modal-sol-detalle">

                        <p className="alert-danger">Al desmatricular al estudiante, este será eliminado del beneficio del código institucional y perderá su nota, avances, tareas y en general toda la información relacionada al curso.</p>
                        <p>¿Aún estás seguro de que deseas desmatricular al estudiante <b>{props.nombres} {props.apellidos}?</b></p>
                        <p><span></span></p>

                        <Button
                            className="ui youtube button"
                            color='red'
                            type="button"
                            icon={'trash alternate'}
                            content="Desmatricular"
                            onClick={handleDelete}
                        />
                    </Container>
                </Modal.Body>
            </Modal>
        </>

    );

})